module.exports = __webpack_public_path__ + "static/media/hotel-palwa.1b88b623.jpg";